<template>
  <button type="button" class="om-button" :class="{ 'om-button-ghost': ghost }" :disabled="isPreparing" @click="download">
    <i class="ni ni-cloud-download-95" aria-hidden="true"></i>
    {{ isPreparing ? copy.preparingPdf : label || copy.downloadPdf }}
  </button>
</template>

<script>
import { MANUAL_COPY } from './manualCopy';

const NEW_TAB = '_blank';

export default {
  name: 'ManualPdfButton',
  props: {
    manualKey: { type: String, required: true },
    versionId: { type: Number, default: null },
    label: { type: String, default: '' },
    ghost: { type: Boolean, default: false },
  },
  data() {
    return { copy: MANUAL_COPY, isPreparing: false };
  },
  methods: {
    async download() {
      const tab = window.open('', NEW_TAB);
      this.isPreparing = true;
      try {
        const url = await this.$store.dispatch('operationsManual/fetchPdfUrl', { manualKey: this.manualKey, versionId: this.versionId });
        if (tab) {
          tab.location.href = url;
        } else {
          window.location.assign(url);
        }
      } catch (error) {
        if (tab) tab.close();
        this.$notify({ type: 'danger', message: this.copy.pdfError });
      } finally {
        this.isPreparing = false;
      }
    },
  },
};
</script>
